class CartDiscount extends HTMLElement {
  #activeFetch = null;
  constructor() {
    super();
    const form = this.querySelector("form");
    form.addEventListener("submit", this.applyDiscount);

    this.addEventListener("click", (event) => {
      if (event.target.closest(".cart-discount-remove")) {
        this.removeDiscount(event);
      }
    });
    this.submitButton = this.querySelector('[type="submit"]');
    this.errorEl = document.querySelector('.cart-discount__error') || document.querySelector('CartDrawer-discount__error');
  }

  #createAbortController() {
    if(this.#activeFetch) this.#activeFetch.abort();

    const abortController = new AbortController();
    this.#activeFetch = abortController;
    return abortController;
  }

  async #updateCartDiscount(discountCodes, abortController) {
    const body = JSON.stringify({discount: discountCodes.join(","), sections: this.getSectionsToRender().map((section) => section.section), sections_url: window.routes.cart_url,});
    console.log(body);
    const response = await fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body: body, signal: abortController.signal } });
    return response.json();
  }

  #updateCartUI(data){
    // Update main cart sections
    this.getSectionsToRender().forEach((section) => {
      if (data.sections && data.sections[section.section]){
        const elementToReplace = document.getElementById(section.id) ?.querySelector(section.selector) || document.getElementById(section.id);
        if(elementToReplace){
          elementToReplace.innerHTML = this.getSectionInnerHTML(data.sections[section.section], section.selector);
        }
      }
    });
    if (typeof freeShippMsg === 'function') freeShippMsg();
  }

  #setLoadingState(isLoading) {
    if (isLoading) {
      this.submitButton.setAttribute("aria-disabled", "true");
      this.submitButton.classList.add("loading");
      this.submitButton.querySelector('.loading__spinner').classList.remove("hidden");
    } else {
      this.submitButton.removeAttribute("aria-disabled");
      this.submitButton.classList.remove("loading");
      this.submitButton.querySelector('.loading__spinner').classList.add("hidden");
    }
  }

  /*** Returns an array of existing discount codes. * @returns {string[]} */
  #existingDiscounts() {
    const discountCodes = [];
    const discountPills = this.querySelectorAll(".discount-code, [data-discount-code]");

    for (const pill of discountPills){
      if (pill instanceof HTMLElement){
        const code = pill.dataset.discountCode || pill.dataset.code;
        if (typeof code === "string" && code.trim()) {
          discountCodes.push(code.trim());
        }
      }
    }
    return discountCodes;
  }
  applyDiscount = async (event) => {
    event.preventDefault();
    event.stopPropagation();

    this.errorEl.classList.add('hidden');
    
    const form = event.target instanceof HTMLFormElement ? event.target : this.querySelector("form");
    const discountCode = form.querySelector('input[name="discount"]');
    const discountCodeValue = discountCode.value.trim();
    if(!discountCodeValue) return;

    // Check if discount already exists
    const existingDiscounts = this.#existingDiscounts();
    if (existingDiscounts.includes(discountCodeValue)){
      this.#handleDiscountError('exist');
      return;
    }

    this.#setLoadingState(true);
    const abortController = this.#createAbortController();

    try {
      const updatedDiscounts = [...existingDiscounts, discountCodeValue];
      const data = await this.#updateCartDiscount(updatedDiscounts, abortController);

      /** @type {{ code: string; applicable: boolean; }} */
      if(data.discount_codes.find((discount) => { return (discount.code === discountCodeValue && discount.applicable === false);})){
        this.#handleDiscountError('discount');
        return;
      }

      discountCode.value = "";
      this.#updateCartUI(data);
      //this.#checkShipCode(discountCodeValue,data.discount_codes);
    } catch (error) {
      var type = "applying discount"
      this.#handleDiscountError(type);
    } finally {
      this.#setLoadingState(false);
      this.#activeFetch = null;
    }
  };

  removeDiscount = async (event) => {
    event.preventDefault();
    event.stopPropagation();
    const removeButton = event.target.closest(".cart-discount-remove");
    removeButton.setAttribute("aria-disabled", "true");
    removeButton.classList.add("loading");
    if(event instanceof KeyboardEvent && event.key !== "Enter") return;

    const discountCode = this.#getDiscountCodeFromEvent(event);
    if(!discountCode) return;

    const existingDiscounts = this.#existingDiscounts();
    const updatedDiscounts = existingDiscounts.filter((code) => code !== discountCode);

    if(updatedDiscounts.length === existingDiscounts.length){
      console.warn("Discount code not found in existing discounts");
      return;
    }

    const abortController = this.#createAbortController();

    try {
      const data = await this.#updateCartDiscount(updatedDiscounts, abortController);
      this.#updateCartUI(data);
    } catch (error) {

    } finally {
      this.#activeFetch = null;
      removeButton.setAttribute("aria-disabled", "false");
      removeButton.classList.remove("loading");
      this.errorEl.classList.add('hidden');
    }
  };

  #getDiscountCodeFromEvent(event) {
    const removeButton = event.target.closest(".discount-code");
    if (!removeButton) return null;
    return (removeButton.dataset.code || removeButton.dataset.discountCode || removeButton.closest("[data-discount-code]")?.dataset.discountCode || null);
  }

  #checkShipCode(code, codes){
    const existingDiscounts = this.#existingDiscounts();
    if(!existingDiscounts.includes(code) && codes.find((discount) => { return (discount.code === code && discount.applicable === true);})){
      this.#handleDiscountError('shipping');
    }
  }
  /*** Handles the discount error. */
  #handleDiscountError(type){
    if(type == 'shipping'){
      this.errorEl.textContent = cartStrings?.discount_ship;
    } else if(type == 'exist'){
      this.errorEl.textContent = cartStrings?.discount_already;
    } else {
      this.errorEl.textContent = cartStrings?.discount_error;
    }
    this.errorEl.classList.remove('hidden');
  }

  getSectionsToRender(){
    const mainCartItems = document.getElementById("main-cart-items");
    if(mainCartItems){
        return [
          {
            id: 'main-cart-items',
            section: document.getElementById('main-cart-items').dataset.id,
            selector: '.js-contents',
          },
          {
            id: 'cart-icon-bubble',
            section: 'cart-icon-bubble',
            selector: '.shopify-section'
          },
          {
            id: 'main-cart-footer',
            section: document.getElementById('main-cart-footer').dataset.id,
            selector: '.cartTotal',
          },
          {
            id: 'CartDrawer',
            section: 'cart-drawer',
            selector: '.drawer__inner'
          },
          {
            id: 'cartDiscount',
            section: document.getElementById('cartDiscount').dataset.id,
            selector: '.cart-discount__codes',
          }
        ];
    } else {
       return [
          {
            id: 'CartDrawer',
            section: 'cart-drawer',
            selector: '.drawer__inner'
          },
          {
            id: 'cartDiscount',
            section: document.getElementById('cartDiscount').dataset.id,
            selector: '.cart-discount__codes',
          }
        ];
    }
  }

  getSectionInnerHTML(html, selector) {
    return ( new DOMParser().parseFromString(html, "text/html").querySelector(selector)?.innerHTML || "" );
  }
}

if (!customElements.get("cart-discount")){
  customElements.define("cart-discount", CartDiscount);
}